import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import React, { useState } from "react";

import Button from "~/components/common/button";
import { useConfiguration } from "~/contexts/configuration";
import { KikReviewsV2Media } from "~/shared/power-reviews-response.interface";
import powerReviewUtils from "~/utils/power-reviews-utils";

import styles from "./review-item-text-preview.module.scss";
import ReviewStars from "./review-stars";
import ReviewTimeAgo from "./review-time-ago";

type Props = {
  media: KikReviewsV2Media;
};

export default function ReviewItemTextPreview(props: Props) {
  const t = useTranslations();
  const [reviewText, setReviewText] = useState<string>();
  const { media } = props;
  const { organizationUnitId } = useConfiguration();
  const router = useRouter();

  const showReview = async (reviewId: string) => {
    try {
      const reviewResponse = await powerReviewUtils.getReviewById(reviewId, organizationUnitId, router.locale!);
      setReviewText(`"${reviewResponse?.details.comments}"`);
    } catch {
      setReviewText(t("reviews.reviewNotAvailable"));
    }
  };

  if (!media) {
    return <></>;
  }

  return (
    <div>
      {media.rating && <ReviewStars rating={media.rating} id={media.id} />}
      <div className={styles.reviewsHeadline}>{media.headline}</div>
      {media.caption && <div className={styles.reviewsCaption}>{`"${media.caption}"`}</div>}
      {reviewText ? (
        <div className={styles.reviewsCaption}>{reviewText}</div>
      ) : (
        <Button className={styles.showReviewButton} onClick={() => showReview(`${media.review_id}`)}>
          {t("reviews.readReview")}
        </Button>
      )}
      {media.created_date && <ReviewTimeAgo timestamp={media.created_date} />}
    </div>
  );
}
